const zh_CN = {
  仪表盘: '仪表盘',
  监控仪表盘: '监控仪表盘',
  内置仪表盘: '内置仪表盘',
  时序指标: '时序指标',
  即时查询: '即时查询',
  快捷视图: '快捷视图',
  记录规则: '记录规则',
  日志分析: '日志分析',
  链路追踪: '链路追踪',
  拓扑分析: '拓扑分析',
  基础设施: '基础设施',
  监控机器: '机器列表',
  告警管理: '告警管理',
  告警规则: '告警规则',
  内置规则: '内置规则',
  屏蔽规则: '屏蔽规则',
  订阅规则: '订阅规则',
  活跃告警: '活跃告警',
  历史告警: '历史告警',
  告警自愈: '告警自愈',
  自愈脚本: '自愈脚本',
  自愈配置: '自愈配置',
  执行历史: '执行历史',
  人员组织: '人员组织',
  用户管理: '用户管理',
  团队管理: '团队管理',
  业务组管理: '业务组管理',
  权限管理: '权限管理',
  系统配置: '系统配置',
  系统版本: '系统版本',
  告警引擎: '告警引擎',
  数据源: '数据源',
  单点登录: '单点登录',
  通知模板: '通知模板',
  通知设置: '通知设置',
};
export default zh_CN;
